import { InputProps } from 'modules/queryBuilder/contexts/visualComponents';
import { InputTextProps } from 'ui/inputs';
import { SelectValueType } from 'ui/selects';

export const getOnInputChange = <TValue extends SelectValueType = string>({
  onChange,
  type,
  isEmpty,
}: Pick<InputProps<TValue | null>, 'onChange'> &
  Pick<InputTextProps, 'type'> & { isEmpty: boolean }) => {
  return <KValue>(input: KValue) => {
    const trimmedInput = `${input}`.trim() || null;
    const formattedInput = type === 'number' ? Number(trimmedInput) : trimmedInput;
    // Don't trigger change if setting empty value for already empty value
    if (!(isEmpty && !trimmedInput)) {
      onChange(formattedInput as TValue);
    }
  };
};
